import { format, formatISO, parseISO } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getDateLang } from './i18n';

export const parseTime = (val: Date | null): string | null => {
  if (!val || isNaN(val.getTime())) {
    return null;
  }
  const hours = val.getHours().toString().padStart(2, '0');
  const minutes = val.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const getDateForApi = (date?: Date | null) =>
  date ? format(date, 'yyyy-MM-dd') : undefined;

export const getDateTimeForApi = (date?: Date | null) =>
  date ? formatISO(date) : undefined;

export const isDateDisabled = (day: Date) => {
  const today = new Date();
  return day <= today;
};

export const formatDate = (i18n?: any, value?: Date | null | string, showWithTime?: boolean, showSeconds?: boolean) => {
  if (!value) return '';
  if (typeof value === 'string') value = parseISO(value);
  const formatString = showWithTime ? (showSeconds ? 'P pp' : 'P p') : 'P';
  return format(value, formatString, {
    locale: i18n ? getDateLang(i18n) : undefined,
  });
};

interface Props {
  value?: Date | null;
  showWithTime?: boolean;
  showSeconds?: boolean;
}

export const DateFormat: FC<Props> = ({ value, showWithTime, showSeconds }) => {
  const { i18n } = useTranslation();

  if (!value) {
    return null;
  }

  return (
    <>
      {formatDate(i18n, value, showWithTime, showSeconds)}
    </>
  );
};
